module.exports = __webpack_public_path__ + "img/1545088042.6ae506bc.jpg";